import { useEffect, useRef } from 'react';
import { useApp } from '@context/AppContext';
import { useChallenge } from './useChallenge';

/**
 * Brief review phase — shows all submissions in a grid for 3 seconds.
 */
export default function ChallengeReview() {
  const { state } = useApp();
  const { game, user } = state;
  const { advanceToVoting } = useChallenge();
  const timerRef = useRef(null);

  const submissions = Object.entries(game.submissions || {});

  // Auto-advance after 5 seconds (host only) — gives time to appreciate the reveal
  useEffect(() => {
    if (!user.isHost) return;
    timerRef.current = setTimeout(() => {
      advanceToVoting();
    }, 5000);
    return () => clearTimeout(timerRef.current);
  }, [user.isHost, advanceToVoting]);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <h2 className="text-2xl font-bold text-white font-display mb-6 animate-pulse">
        Time&apos;s up! See what everyone drew...
      </h2>

      <div className={`grid gap-4 ${
        submissions.length <= 4 ? 'grid-cols-2' : 'grid-cols-3'
      } max-w-2xl w-full`}>
        {submissions.map(([userId, sub]) => (
          <div
            key={userId}
            className="bg-white rounded-xl overflow-hidden shadow-lg animate-[fadeIn_0.5s_ease-out]"
          >
            <img
              src={sub.imageData}
              alt={`${sub.nickname}'s drawing`}
              className="w-full aspect-[4/3] object-cover bg-canvas"
            />
            <div className="px-3 py-2">
              <p className="text-sm font-display text-charcoal truncate">{sub.nickname}</p>
            </div>
          </div>
        ))}
      </div>

      {user.isHost && (
        <button
          onClick={advanceToVoting}
          className="mt-6 px-6 py-2.5 rounded-xl bg-amber text-white text-sm font-semibold font-display hover:bg-amber/90 transition-colors"
        >
          Skip to Voting
        </button>
      )}
    </div>
  );
}
